import { chakra, Flex } from "@chakra-ui/react";

export { Flex as FlexRow };

/* Will typescript ever support module augmentation? or w/e it's called. */
export const FlexColumn = chakra(Flex, {
  baseStyle: { flexDirection: "column" }
});
